var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"section-row"},_vm._l((_vm.data.value),function(item,index){return _c('p',{key:index,class:[ { 'single-column': _vm.data.value.length === 1 || _vm.data.single } ],domProps:{"innerHTML":_vm._s(item)}})}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }